import React, { useState } from "react";
import { Divider, Form, Input } from "antd";
import MarketLogo from "../../../../assets/images/logo-removebg.png";
import Image from "../../../common/image/Image";
import {
	AlertBox,
	Body,
	Container,
	DividerLine,
	DividerText,
	Footer,
	ForgotLink,
	ForgotLinkWrap,
	Header,
	HeaderDesc,
	HeaderTitle,
	InnerForm,
	LogoWrap,
	Main,
	Page,
	PrimaryButtonWrap,
	Section,
	TrustDot,
	TrustItem,
	TrustRow,
} from "./styles";
import { useAuth } from "../../../../contexts/authContext";
import SignInTemplate from "../../../layout/sign-in-template/SignInTemplate";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../utils/notificationToast";
import { Typo } from "../../../layout/theme";
import {
	ClockCircleOutlined,
	LockOutlined,
	LoginOutlined,
	MailOutlined,
	SafetyOutlined,
} from "@ant-design/icons";

export default function SignIn({
	newUserData = null,
	deletedUser = false,
	blockedUser = false,
}) {
	const { login, logout } = useAuth();
	const [form] = Form.useForm();
	const [submitting, setSubmitting] = useState(false);

	const onFinish = async (values) => {
		try {
			setSubmitting(true);

			if (deletedUser) {
				openNotificationWithIcon(
					TYPE.ERROR,
					"Su usuario ha sido inhabilitado",
					"Por favor espere a ser habilitado para el ingreso",
				);
				setSubmitting(false);
				return false;
			}

			if (blockedUser) {
				openNotificationWithIcon(
					TYPE.ERROR,
					"No se permite el login del usuario",
					"Por favor revise sus permisos y credenciales.",
				);
				setSubmitting(false);
				return false;
			}

			if (newUserData) {
				openNotificationWithIcon(
					TYPE.ERROR,
					"Su solicitud sigue en revisión",
					"Por favor espere a ser validado para el ingreso. Este proceso puede demorar 48hs.",
				);
				setSubmitting(false);
				return false;
			}

			if (!values.email || !values.password) return false;
			await login(values.email, values.password);
		} catch (error) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"No se permite el login del usuario",
				"Por favor revise sus credenciales",
			);
		} finally {
			setSubmitting(false);
		}
	};

	const handleInputMailfocus = async () => {
		if (newUserData || deletedUser || blockedUser) {
			localStorage.clear();
			await logout();
		}
	};

	return (
		<SignInTemplate columns="1">
			<Page>
				<Main>
					<LogoWrap>
						<Image
							src={MarketLogo}
							alt="Logo One Transfer"
							height="45px"
							width="220px"
						/>
					</LogoWrap>

					<Header>
						<HeaderTitle>Iniciar sesión</HeaderTitle>
						<HeaderDesc>
							Ingresá tu email y contraseña para acceder al sistema
						</HeaderDesc>
					</Header>

					<Body>
						<Form
							form={form}
							name="sign-in-form"
							onFinish={onFinish}
							requiredMark={false}
							layout="vertical"
						>
							<InnerForm>
								{newUserData && (
									<AlertBox>
										Solicitud pendiente de aprobación. Por favor espere a ser
										validado. Este proceso puede demorar hasta 48 hs.
									</AlertBox>
								)}

								{deletedUser && (
									<AlertBox>
										Su usuario ha sido deshabilitado para operar en el sitio.
									</AlertBox>
								)}

								{blockedUser && (
									<AlertBox>
										Su usuario no puede ingresar en este sitio.
									</AlertBox>
								)}

								<Section>
									<Section
										style={{
											flexDirection: "row",
											justifyContent: "space-between",
										}}
									>
										<Form.Item
											name="email"
											label="Email"
											rules={[
												{
													required: true,
													message: "Este campo es obligatorio",
												},
											]}
										>
											<Input
												placeholder="usuario@correo.com"
												type="email"
												size="large"
												prefix={<MailOutlined />}
												onFocus={handleInputMailfocus}
												style={{ width: 280 }}
											/>
										</Form.Item>

										<Form.Item
											name="password"
											label="Contraseña"
											rules={[
												{
													required: true,
													message: "Este campo es obligatorio",
												},
											]}
										>
											<Input.Password
												size="large"
												placeholder="••••••••"
												prefix={<LockOutlined />}
												style={{ width: 280 }}
											/>
										</Form.Item>
									</Section>
									<ForgotLinkWrap>
										<ForgotLink>
											<SignInTemplate.NavLink to="/forgot-password">
												¿Olvidaste tu contraseña?
											</SignInTemplate.NavLink>
										</ForgotLink>
									</ForgotLinkWrap>
								</Section>

								<Divider>
									<DividerLine />
									<DividerText>acceso</DividerText>
									<DividerLine />
								</Divider>
								<Container>
									<PrimaryButtonWrap>
										<SignInTemplate.AntdButton
											htmlType="submit"
											loading={submitting}
											type="primary"
											color="White"
											bg="Secondary"
											icon={<LoginOutlined />}
										>
											Iniciar Sesión
										</SignInTemplate.AntdButton>
									</PrimaryButtonWrap>
								</Container>

								<Footer>
									Al ingresar aceptás los Términos de uso y la Política de
									privacidad
								</Footer>

								<TrustRow>
									<TrustItem>
										<SafetyOutlined />
										Conexión segura
									</TrustItem>

									<TrustDot />

									<TrustItem>
										<LockOutlined />
										Datos encriptados
									</TrustItem>

									<TrustDot />

									<TrustItem>
										<ClockCircleOutlined />
										Disponible 24/7
									</TrustItem>
								</TrustRow>
							</InnerForm>
						</Form>
					</Body>
				</Main>
			</Page>
		</SignInTemplate>
	);
}
